'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { Icon, Link } from '@weareconceptstudio/core';

//* Styles
import ShareStyle from './style';

const Share = ({ className = '' }) => {
	//! Next Navigation
	const pathname = usePathname();

	const url = useMemo(() => process.env.NEXT_PUBLIC_URL + pathname, [pathname]);

	const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
	const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
	const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`;

	return (
		<ShareStyle className={`share-wrapper ${className}`}>
			<Link
				external
				url={facebookUrl}
				className={'fb-icon'}
			>
				<Icon
					className={'h6 media-share'}
					name={'facebook'}
				/>
			</Link>

			<Link
				external
				url={linkedinUrl}
				className={'linkedin-icon'}
			>
				<Icon
					className={'h6 media-share'}
					name={'linkedin'}
				/>
			</Link>

			<Link
				external
				url={twitterUrl}
				className={'x-icon'}
			>
				<Icon
					className={'h6 media-share'}
					name={'twitter'}
				/>
			</Link>
		</ShareStyle>
	);
};

export default Share;
